import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from 'seagull';
import { NotificationEditField } from '~/components/NotificationEditField/NotificationEditField';
import styles from '../AdHocBillModal.module.scss';
export const EmailContentSection = (param)=>{
    let { testIds, texts } = param;
    const { control } = useFormContext();
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.section,
        testId: testIds.Section(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                weight: "normal",
                className: styles.sectionTitle,
                children: texts.sectionTitle()
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "emailSubject",
                render: (renderProps)=>/*#__PURE__*/ _jsx(NotificationEditField, {
                        bi: {
                            name: 'email_subject'
                        },
                        disableCustomTags: true,
                        label: texts.subjectLabel(),
                        testId: testIds.Subject(),
                        value: renderProps.field.value,
                        onChange: renderProps.field.onChange
                    })
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "emailContent",
                render: (renderProps)=>/*#__PURE__*/ _jsx(NotificationEditField, {
                        bi: {
                            name: 'email_content'
                        },
                        disableCustomTags: true,
                        multiline: true,
                        minRows: 6,
                        label: texts.contentLabel(),
                        testId: testIds.Content(),
                        value: renderProps.field.value,
                        onChange: renderProps.field.onChange,
                        adornmentClassName: styles.emailContentAdornment
                    })
            })
        ]
    });
};
